import { KeyRound, Smartphone } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { MfaMethod } from '../types';

const METHOD_LABELS: Record<MfaMethod, string> = {
	totp: 'Authenticator app',
	recovery_code: 'Recovery code',
};

const METHOD_ICONS: Record<MfaMethod, typeof Smartphone> = {
	totp: Smartphone,
	recovery_code: KeyRound,
};

interface MethodToggleProps {
	methods: MfaMethod[];
	value: MfaMethod;
	onChange: (method: MfaMethod) => void;
	disabled?: boolean;
}

/** Segmented control for choosing how to prove the second factor. */
export function MethodToggle({
	methods,
	value,
	onChange,
	disabled,
}: MethodToggleProps) {
	if (methods.length <= 1) return null;

	return (
		<div
			role="group"
			aria-label="Verification method"
			className="bg-muted flex rounded-md p-0.5"
		>
			{methods.map((method) => {
				const Icon = METHOD_ICONS[method];
				const active = method === value;

				return (
					<button
						key={method}
						type="button"
						aria-pressed={active}
						disabled={disabled}
						onClick={() => onChange(method)}
						className={cn(
							'inline-flex flex-1 items-center justify-center gap-2 rounded-sm px-3 py-1.5 text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50',
							active
								? 'bg-background text-foreground shadow-xs'
								: 'text-muted-foreground hover:text-foreground',
						)}
					>
						<Icon className="size-4" />
						{METHOD_LABELS[method]}
					</button>
				);
			})}
		</div>
	);
}

export { METHOD_LABELS };
